import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'spoilerChunks', standalone: true })
@Injectable({ providedIn: 'root' })

/**
 * Diese Pipe zerlegt einen HTML-String in Spoiler- und Nicht-Spoiler-Teile (Chunks).
 * Sie erkennt folgenden Tag <span data-mx-spoiler> als Spoiler und gibt ein Array aus,
 * welcher für jeden Abschnitt angibt, ob er ein Spoiler ist.
 * Begründung: Wird benötigt, um den Spoiler-Part herauszufiltern.
 */
export class SpoilerChunksPipe implements PipeTransform {
  transform(html: string): SpoilerChunk[] {
    if (!html) return [];

    const result: SpoilerChunk[] = [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.body.childNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node as HTMLElement;
        if (el.tagName.toLowerCase() === 'span' && el.dataset['mxSpoiler'] !== undefined) {
          result.push({ isSpoiler: true, content: el.innerHTML });
        } else {
          result.push({ isSpoiler: false, content: el.outerHTML });
        }
      } else if (node.nodeType === Node.TEXT_NODE) {
        const text: string = node.textContent || '';
        if (text) {
          result.push({ isSpoiler: false, content: text });
        }
      }
    });
    return result;
  }
}

export interface SpoilerChunk {
  isSpoiler: boolean;
  content: string;
}
